/**
 * Widget runtime configuration with working local-dev defaults.
 *
 * Like the dashboard's `config/env.ts`, every value falls back to a functional
 * localhost default so the widget works out-of-the-box in dev without a `.env`.
 * In production these are provided at build time (VITE_API_BASE_URL / VITE_WS_BASE_URL).
 *
 * Both are ORIGIN-ONLY (no `/api/v1`): the shared API client's endpoint builders
 * prepend `/api/v1`, and the WS hooks append `/api/v1/ws/...` themselves.
 */
function originOr(value: string | undefined, fallback: string): string {
  return value && value.trim() ? value.replace(/\/+$/, '') : fallback;
}

export const widgetEnv = {
  /** Backend REST origin, e.g. `http://localhost:8000`. */
  apiBaseUrl: originOr(import.meta.env.VITE_API_BASE_URL, 'http://localhost:8000'),
  /** Backend WS origin, e.g. `ws://localhost:8000`. */
  wsBaseUrl: originOr(import.meta.env.VITE_WS_BASE_URL, 'ws://localhost:8000'),
};
